/* eslint-disable */

import React from "react";
import Modal from "react-bootstrap/Modal";
import APIClient from "../client";
import { Tab, Tabs } from "react-bootstrap";
import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { interpolate } from "../../shared/utils/legacy";
import Tractors from "./Tractors";
import Jobs from "./Jobs";

class LinkCNH extends React.Component {
  state = {
    showModal: false,
    account: null,
    showWarning: false,
  };

  constructor(props, context) {
    super(props, context);
    this.loadAccount();
  }

  componentDidMount() {
    cropr.updateCNHState = () => {
      this.loadAccount();
    };
  }
  componentWillUnmount() {
    delete cropr.updateCNHState;
  }

  loadAccount = async () => {
    fetch("/apps/cloudfarm/get_tractors/CNH/")
      .then((response) => {
        if (response.status === 401) {
          cropr.notify(
            "danger",
            interpolate(gettext("Your %s authorization seems to be no longer valid."), [
              "CNH Industrial",
            ])
          );
        }
        if (response.ok) {
          response.json().then((account) => {
            this.setState({
              account: account,
              company: account.selected_company_name,
              companies: account.companies,
              tractors: account.tractors,
              showWarning: false,
            });
          });
        } else {
          throw { status: response.status };
        }
      })
      .catch((error) => {
        this.setState({
          account: null,
          company: null,
          companies: null,
          tractors: null,
        });
      });
  };

  authorizeAccount = () => {
    fetch("/apps/cloudfarm/cnh_authorization_url/")
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          cropr.notify("danger", gettext("Your account could not be linked at this time."));
          throw new Error(response.status);
        }
      })
      .then((json) => {
        window.open(json.cnh_authorization_url, "_blank");
        this.setState({ showWarning: true });
      })
      .catch((error) => console.error("Error:", error));
  };

  removeAccount = async () => {
    try {
      await APIClient.remove(
        "/api/data/cnh/delete_cnh_credentials",
        null,
        cropr.cloudfarm_oauth_token
      );
      cropr.notify("success", gettext("Your account has been deleted successfully."));
      this.loadAccount();
    } catch {
      cropr.notify("danger", gettext("Your account could not be deleted at this time."));
    }
  };

  toggle = (show) => {
    this.setState({ showModal: show });
  };

  handleCompanyChange = async (event) => {
    const selectedCompanyId = event.target.value;
    const selectedCompanyName = this.state.companies.find(
      (company) => company.companyId === selectedCompanyId
    )?.companyName;

    const formData = new FormData();
    formData.append("company_id", JSON.stringify(selectedCompanyId));
    formData.append("company_name", JSON.stringify(selectedCompanyName));

    try {
      await APIClient.post(
        "/api/data/cnh/set_company",
        { formData: formData },
        cropr.cloudfarm_oauth_token
      );
      cropr.notify("success", gettext("Company changed successfully."));
      this.loadAccount();
    } catch {
      cropr.notify("danger", gettext("Failed to change company."));
    }
  };

  render() {
    return (
      <>
        <button className="dropdown-item" onClick={() => this.toggle(true)}>
          {gettext("Connect with CNH")}
        </button>
        <Modal show={this.state.showModal} onHide={() => this.toggle(false)}>
          <Modal.Header closeButton>
            <Modal.Title style={{ width: "100%" }}>
              CNH Industrial
              <img
                className="float-right"
                src="/static/img/CNH_Industrial.png"
                alt="CNH"
                style={{ height: "30px" }}
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs defaultActiveKey="account">
              <Tab eventKey="account" title={gettext("Account")}>
                {this.state.showWarning ? (
                  <div className="alert alert-info">
                    {gettext("Be sure to allow this page to open popup windows in your browser.")}
                  </div>
                ) : null}
                {this.state.account ? (
                  <div>
                    <h4 className="mt-2">
                      {gettext("Currently linked account")}: {this.state.company}
                    </h4>
                    {this.state.companies && this.state.companies.length > 1 ? (
                      <div className="mt-4">
                        <h4 className="mt-2">{gettext("Switch company")}:</h4>
                        <select className="form-control" onChange={this.handleCompanyChange}>
                          {this.state.companies.map((company) => (
                            <option key={company.companyId} value={company.companyId}>
                              {company.companyName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : null}
                    <div className="mt-4">
                      <button className="btn btn-warning mr-1" onClick={() => this.removeAccount()}>
                        {gettext("Delete")}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="mt-4">
                      <button className="btn btn-primary" onClick={() => this.authorizeAccount()}>
                        {gettext("Authorize")}
                      </button>
                    </div>
                  </div>
                )}
              </Tab>
              <Tab eventKey="tractors" title={gettext("Tractors")} disabled={!this.state.account}>
                {this.state.company ? (
                  <Tractors
                    accountName={this.state.company}
                    headers={[
                      gettext("Name"),
                      gettext("Vehicle Type"),
                      gettext("Vehicle Model"),
                      gettext("Serial Number"),
                    ]}
                    tractors={this.state.tractors.map((t) => ({
                      display: [
                        t.vehicleName === "" ? "-" : t.vehicleName,
                        t.vehicleType,
                        t.vehicleModel,
                        t.vehicleSN,
                      ],
                      serialNr: t.vehicleId,
                      receiveOnly: true,
                    }))}
                    noActions={true}
                  />
                ) : null}
              </Tab>
              <Tab eventKey="tasks" title={gettext("Tasks")} disabled={!this.state.account}>
                {this.state.account ? <Jobs online_service="CNH" /> : null}
              </Tab>
              <Tab eventKey="help" title={gettext("Help")}>
                <h5 className="mt-2">{gettext("What is a connection to CNH Industrial?")}</h5>
                {interpolate(
                  gettext(
                    "If you possess equipment that is connected to %s, you can authorize Cloudfarm to exchange data with this platform. Please talk to your dealer for more information about this system."
                  ),
                  ["CNH Industrial"]
                )}
                <h5 className="mt-2">{gettext("What can I do with it?")}</h5>
                {gettext(
                  "You can exchange task data directly between your vehicle and The Dacom platform/ Cloudfarm:"
                )}
                <ul>
                  <li>
                    {gettext(
                      'After connecting, your vehicle(s) will be present under the "Machines" menu. There, you can rename your vehicle, and attach a default recording template.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'After completing a task on the vehicle, the "as applied" data is automatically loaded in Cloudfarm, where you can review the work done.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'If you use the vehicle to record field boundaries and way lines, you can easily import them into your Dacom farm by clicking "details" in the dataset card and go to the "geometry" tab. This way you can easily reuse this data for other vehicles, for instance by converting them into a different format with the "export machine data" functionality. '
                    )}
                  </li>
                </ul>
              </Tab>
            </Tabs>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default LinkCNH;
